import { createContext, useContext } from 'react';
export const ExperimentsContext = createContext({
    useExperiments() {
        return { loading: false, error: new Error('Missing experiments module') };
    },
    useExperiment(
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    _name, 
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    _fallback) {
        return 'A';
    },
    useExperimentTrackingData() {
        return {};
    },
});
export function useExperiments() {
    return useContext(ExperimentsContext).useExperiments();
}
export function useExperiment(name, fallback) {
    return useContext(ExperimentsContext).useExperiment(name, fallback);
}
export function useExperimentTrackingData() {
    return useContext(ExperimentsContext).useExperimentTrackingData();
}
//# sourceMappingURL=experiments.js.map